//Global
export const UPDATE_LANG = "UPDATE_LANG";

export const LOADING_SPINER = "LOADING_SPINER";

export const SUCCESS_MODAL_PROCESS = "SUCCESS_MODAL_PROCESS";

export const ERROR_MODAL_PROCESS = "ERROR_MODAL_PROCESS";
